/**
 * Helper method to remove tabs, new lines and unnecessary whitespaces of the text input
 * @param value the unformatted input target value
 * @param removeSpaces used to also remove all " " characters
 * @returns the value as normalized string
 */
export const normalizeTextInput = (value: string, removeSpaces?: boolean): string => {
  const removeTabRegex: RegExp = /\t/g;
  const removeNewLineRegex: RegExp = /\r\n|\r|\n/g;
  const removeSpaceRegex: RegExp = / /g;
  let result: string = value
    .normalize('NFC')
    .replace(removeTabRegex, ' ')
    .replace(removeNewLineRegex, ' ');
  if (removeSpaces) return result.replace(removeSpaceRegex, '');
  return result;
};
